import { Button as ButtonMui, styled, TextField as TextFieldBase } from '@mui/material';
import { Table as TableBase } from '../../../pages/contact/patient-profile/patient-profile-page.styles';
import { CardTitle as CardTitleBase } from '../../card/card.style';
import { DialogTitle as DialogTitleBase } from '../../dialog/dialog.styles';

export const CardTitle = styled(CardTitleBase)({
  padding: 20,
  margin: '-16px -16px 0',
  borderBottom: '1px solid #EDEFF2',
  span: {
    fontWeight: 400,
    fontSize: 14,
    marginRight: 38,
    display: 'inline-block'
  }
});

export const InfoTitle = styled('b')({
  fontWeight: 700
});

export const Score = styled('span')({
  fontWeight: 700,
  '&.high': {
    color: '#28A745'
  },
  '&.warning': {
    color: '#D59900'
  },
  '&.danger': {
    color: '#E31B0C'
  }
});

export const YesNo = styled('span')({
  fontWeight: 700,
  '&.yes': {
    color: '#28A745'
  },
  '&.no': {
    color: '#E31B0C'
  }
});

export const Table = styled(TableBase)({
  marginBottom: 0,
  '&.table-info': {
    margin: 0,
    marginBottom: 16,
    '.MuiTableCell-root': {
      fontSize: 16,
      borderBottom: 'none'
    },
    '.star-rating': {
      marginTop: 7
    }
  }
});

export const DialogTitle = styled(DialogTitleBase)({
  margin: '20px 40px -20px'
});

const ButtonBase = styled(ButtonMui)({
  color: '#fff',
  fontSize: 12,
  fontWeight: 700,
  minWidth: 147,
  height: 30,
  lineHeight: 28,
  borderRadius: 3,
  marginRight: 10,
  justifyContent: 'left',
  textTransform: 'none',
  '.MuiButton-startIcon': {
    backgroundColor: 'rgba(255,255,255,.3)',
    margin: '-10px 10px -10px -10px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 30,
    width: 30
  },
  '&.inactive': {
    backgroundColor: '#EDEFF2',
    border: '1px solid #EDEFF2',
    color: '#8D97A4',
    '&:hover': {
      backgroundColor: '#EDEFF2'
    }
  }
});

export const FacebookButton = styled(ButtonBase)({
  backgroundColor: '#3b5998',
  border: '1px solid #3b5998',
  '&:hover': {
    backgroundColor: '#2d4373'
  }
});

export const TwitterButton = styled(ButtonBase)({
  backgroundColor: '#1DA1F2',
  border: '1px solid #1A91DA',
  '&:hover': {
    backgroundColor: '#1A91DA'
  }
});

export const GoogleButton = styled(ButtonBase)({
  backgroundColor: '#DB4437',
  border: '1px solid #c4372c',
  '&:hover': {
    backgroundColor: '#c4372c'
  }
});

export const Hr = styled('hr')({
  width: 'calc(100% + 32px)',
  margin: '0 -16px',
  border: 'none',
  borderBottom: '1px solid #EDEFF2'
});

export const TextField = styled(TextFieldBase)({
  marginTop: 10,
  width: 'calc(100% - 32px)',
  border: '1px solid #8D97A4',
  borderRadius: 4,
  '.MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  '.MuiInputBase-input': {
    width: '100%',
    boder: 'none'
  }
});

export const ReviewOldPage = styled('div')({
  '.MuiButtonBase-root': {
    fontSize: 16,
    marginTop: -5,
    padding: 0
  }
});
